<div class="subscription-container">
    <!-- Page Header -->
    <div class="subscription-header">
        <div class="header-content">
            <h2 class="subscription-title">
                <fa-icon [icon]="icons.faCreditCard" class="title-icon"></fa-icon>
                Subscription Plans
            </h2>
            <p class="subscription-subtitle">Choose the perfect plan for your needs</p>
        </div>
    </div>

    <!-- Current Subscription Info -->
    <div class="current-subscription-box" *ngIf="currentProduct?.id && currentPrice?.id">
        <div class="subscription-status">
            <div class="status-left">
                <fa-icon [icon]="icons.faCheckCircle" class="status-icon"></fa-icon>
                <div class="status-text">
                    <h3 class="status-title">Current Plan</h3>
                    <p class="status-detail">{{ currentProduct?.name }} - {{ formatCurrency((currentPrice?.unit_amount || 0) / 100, 'en-us', '$') }} per {{ currentPrice?.interval }}</p>
                </div>
            </div>
            <button class="btn-manage-subscription" (click)="gotoCustomerPortal()">
                <fa-icon [icon]="icons.faCog"></fa-icon>
                Manage Subscription
            </button>
        </div>
    </div>

    <!-- Plans Grid -->
    <div class="plans-grid">
        <div 
            class="plan-card" 
            *ngFor="let product of products"
            [class.current-plan]="currentProduct?.id == product.id"
        >
            <div class="plan-header">
                <h3 class="plan-name">{{ product.name }}</h3>
                <p class="plan-description">{{ product.description }}</p>
            </div>

            <div class="plan-pricing">
                <div class="pricing-list" *ngFor="let price of product.prices">
                    <div class="price-item">
                        <div class="price-amount">
                            <span class="currency">$</span>
                            <span class="amount">{{ (price.unit_amount || 0) / 100 | number: '1.2-2' }}</span>
                            <span class="interval">/ {{ price.interval }}</span>
                        </div>
                        <p class="price-description" *ngIf="price.description">{{ price.description }}</p>
                        
                        <!-- Current Plan Badge -->
                        <div class="plan-status" *ngIf="currentProduct?.id == product.id && currentPrice?.id == price.id">
                            <span class="status-badge active">
                                <fa-icon [icon]="icons.faCheck"></fa-icon>
                                Current Plan
                            </span>
                        </div>

                        <!-- Not Logged In Message -->
                        <div class="plan-alert" *ngIf="!authService.userData">
                            <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                            <span>Sign in to purchase</span>
                        </div>

                        <!-- Action Button -->
                        <div class="plan-actions">
                            <button 
                                class="btn-purchase"
                                (click)="purchase(price)"
                                [disabled]="!authService.isLoggedIn || (currentProduct?.id == product.id && currentPrice?.id == price.id)"
                                *ngIf="!currentProduct?.id || !currentPrice?.id || (currentProduct?.id != product.id || currentPrice?.id != price.id)"
                            >
                                <fa-icon [icon]="icons.faShoppingCart"></fa-icon>
                                Select Plan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- No Plans Message -->
    <div class="empty-state" *ngIf="!products || products.length === 0">
        <div class="empty-content">
            <fa-icon [icon]="icons.faBoxOpen" class="empty-icon"></fa-icon>
            <h3 class="empty-title">No Plans Available</h3>
            <p class="empty-description">Plans are currently being configured. Please check back soon.</p>
        </div>
    </div>

    <!-- Info Box -->
    <div class="info-box">
        <fa-icon [icon]="icons.faInfoCircle" class="info-icon"></fa-icon>
        <div class="info-content">
            <strong>Questions about plans?</strong>
            <p>All plans include access to core features. You can upgrade, downgrade, or cancel your subscription at any time.</p>
        </div>
    </div>
</div>